<template>
    <div>
        <div class="content3">
            <div class="title-box">{{ $t('sportRecord.record0.name') }}</div>
            <div class="item-title item-title1">{{ $t('sportRecord.record0.record0') }}</div>
            <div class="item-date item-date1">{{record.stepDayDate ? changeDate(record.stepDayDate) : '--'}}</div>
            <div class="item-value item-value1">{{record.stepDay ? format(record.stepDay) : '--'}}</div>
            <div class="item-title item-title2">{{ $t('sportRecord.record0.record1') }}</div>
            <div class="item-date item-date2">{{record.stepWeeklyBegin ? changeDate(record.stepWeeklyBegin) + "-" + changeDate(record.stepWeeklyEnd) : '--'}}
            </div>
            <div class="item-value item-value2">{{record.stepWeekly ? format(record.stepWeekly) : '--'}}</div>
            <div class="item-title item-title3">{{ $t('sportRecord.record0.record2') }}</div>
            <div class="item-date item-date3">{{record.stepMonth ? changeDateM(record.stepMonthDate) : '--'}}</div>
            <div class="item-value item-value3">{{record.stepMonth ? format(record.stepMonth) : '--'}}</div>
        </div>
        <div class="content2">
            <div class="title-box2 ">{{ $t('sportRecord.record1.name') }}</div>
            <div class="item-title item-title1">{{ $t('sportRecord.record1.record0') }}</div>
            <div class="item-date item-date1">{{record.runMileageDate ? changeDate(record.runMileageDate) : '--'}}</div>
            <div class="item-value item-value1">{{record.runMileage ? (record.runMileage / 100000).toFixed(2) : '--'}}
            </div>
            <div class="item-title item-title2">{{ $t('sportRecord.record1.record1') }}</div>
            <div class="item-date item-date2">{{record.runPaceDate ? changeDate(record.runPaceDate) : '--'}}</div>
            <div class="item-value item-value2">{{record.runPace ? formatSeconds(record.runPace) : '--'}}</div>
        </div>

        <div class="content2">
            <div class="title-box">{{ $t('sportRecord.record2.name') }}</div>
            <div class="item-title item-title1">{{ $t('sportRecord.record2.record0') }}</div>
            <div class="item-date item-date1">{{record.rideMileageDate ? changeDate(record.rideMileageDate) : '--'}}
            </div>
            <div class="item-value item-value1">{{record.rideMileage ? (record.rideMileage / 100000).toFixed(2) :
                '--'}}
            </div>
            <div class="item-title item-title2">{{ $t('sportRecord.record2.record1') }}</div>
            <div class="item-date item-date2">{{record.ridePaceDate ? changeDate(record.ridePaceDate) : '--'}}</div>
            <div class="item-value item-value2">{{record.ridePace ? formatSeconds(record.ridePace) : '--'}}</div>
        </div>

        <div class="content2">
            <div class="title-box2 ">{{ $t('sportRecord.record3.name') }}</div>
            <div class="item-title item-title1">{{ $t('sportRecord.record3.record0') }}</div>
            <div class="item-date item-date1">{{record.swimMileageDate ? changeDate(record.swimMileageDate) : '--'}}
            </div>
            <div class="item-value item-value1">{{record.swimMileage ? (record.swimMileage / 100000).toFixed(2) :
                '--'}}
            </div>
            <div class="item-title item-title2">{{ $t('sportRecord.record3.record1') }}</div>
            <div class="item-date item-date2">{{record.swimSwolfDate ? changeDate(record.swimSwolfDate) : '--'}}</div>
            <div class="item-value item-value2">{{record.swimSwolf ? formatSeconds(record.swimSwolf) : '--'}}</div>
        </div>

        <div class="content1">
            <div class="title-box2 ">{{ $t('sportRecord.record4.name') }}</div>
            <div class="item-title item-title1">{{ $t('sportRecord.record4.record0') }}</div>
            <div class="item-date item-date1">{{record.climbHeightDate ? changeDate(record.climbHeightDate) : '--'}}
            </div>
            <div class="item-value item-value1">{{record.climbHeight ? format(record.climbHeight) : '--'}}</div>
        </div>
    </div>
</template>

<script>
    import {changeDateY, changeDateM, formatSeconds, formatSeconds2} from '@/utils/dateUtils'

    export default {
        name: 'sportRecord',
        data() {
            return {
                record: {
                    "stepDay": 0,
                    "stepDayDate": "",
                    "stepWeekly": 0,
                    "stepWeeklyBegin": "",
                    "stepWeeklyEnd": "",
                    "stepMonth": 0,
                    "stepMonthDate": "",
                    "runMileage": 0,
                    "runMileageDate": "",
                    "runPace": 0,
                    "runPaceDate": "",
                    "rideMileage": 0,
                    "rideMileageDate": "",
                    "ridePace": 0,
                    "ridePaceDate": "",
                    "swimMileage": 0,
                    "swimMileageDate": null,
                    "swimSwolf": 0,
                    "swimSwolfDate": null,
                    "climbHeight": 0,
                    "climbHeightDate": "",
                    "stepTotal": 0,
                    "runTotal": 0,
                    "rideTotal": 0,
                    "swimTotal": 0,
                    "climbTotal": 0,
                    "climbHeightTotal": 0
                }
            }
        },
        mounted() {
            if (this.$route.query.token) {
                localStorage.setItem("token", this.$route.query.token);
            }
            this.getInfo();
        },
        methods: {
            getInfo() {
                this.$api.my.getUserRecord().then(res => {
                    this.record = res.info;
                })
            },
            changeDate(n) {
                return changeDateY(n);
            },
            changeDateM(n) {
                return changeDateM(n);
            },
            formatSeconds(n) {
                return formatSeconds(n);
            },
            format(num){
                num = num.toString();
                //如果存在小数点，则获取数字的小数部分
                var cents = num.indexOf(".") > 0 ? num.substr(num.indexOf(".")) : '';
                cents = cents.length > 1 ? cents : '';
                //获取数字的整数数部分
                num = num.indexOf(".") > 0 ? num.substring(0, (num.indexOf("."))) : num;
                for (var i = 0; i < Math.floor((num.length - (1 + i)) / 3); i++) {
                    num = num.substring(0, num.length - (4 * i + 3)) + ',' + num.substring(num.length - (4 * i + 3));
                }
                //将数据（符号、整数部分、小数部分）整体组合返回
                return (num + cents);
            }
        },
    }
</script>

<style scoped>

    .content3 {
        width: 345px;
        height: 227px;
        margin: 15px auto 20px;
        background: url("~@/assets/theme/light/sport/05sportRecord/01bg.png") no-repeat;
        background-size: 345px 227px;
        position: relative;
    }

    .content2 {
        width: 345px;
        height: 166px;
        margin: 15px auto 20px;
        background: url("~@/assets/theme/light/sport/05sportRecord/02bg.png") no-repeat;
        background-size: 345px 166px;
        position: relative;
    }

    .content1 {
        width: 345px;
        height: 105px;
        margin: 15px auto 20px;
        background: url("~@/assets/theme/light/sport/05sportRecord/03bg.png") no-repeat;
        background-size: 345px 105px;
        position: relative;
    }

    .title-box {
        width: 62px;
        height: 24px;
        background: var(--text-color-1);
        border-radius: 12px 12px 12px 12px;
        color: var(--bg-color-2);
        font-size: 12px;
        display: flex;
        justify-content: center;
        align-items: center;
        position: absolute;
        left: 18px;
        top: 8px;
    }

    .title-box2 {
        width: 62px;
        height: 24px;
        border-radius: 12px 12px 12px 12px;
        border: 2px solid var(--text-color-1);
        color: var(--text-color-1);
        font-size: 12px;
        display: flex;
        justify-content: center;
        align-items: center;
        position: absolute;
        left: 18px;
        top: 8px;
    }

    .item-title {
        font-size: 12px;
        color: var(--text-color-1);
        position: absolute;
        left: 20px;
    }

    .item-title1 {
        top: 52px;
    }

    .item-title2 {
        top: 113px;
    }

    .item-title3 {
        top: 174px;
    }

    .item-date {
        font-size: 13px;
        color: var(--text-color-2);
        position: absolute;
        left: 20px;
    }

    .item-date1 {
        top: 76px;
    }

    .item-date2 {
        top: 137px;
    }

    .item-date3 {
        top: 198px;
    }

    .item-value {
        font-size: 24px;
        color: var(--text-color-1);
        position: absolute;
        right: 20px;
    }

    .item-value1 {
        top: 53px;
    }

    .item-value2 {
        top: 114px;
    }

    .item-value3 {
        top: 175px;
    }
</style>



// WEBPACK FOOTER //
// src/views/sport/05sportRecord.vue